import React, { Component } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { DropDownList } from "@progress/kendo-react-dropdowns";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import LinkedEntitySidebar from "./LinkedEntitySidebar";
import CreateLinkDialog from "./CreateLinkDialog";
import { Splitter } from "@progress/kendo-react-layout";
import CardinalityOptionsField from "./Field/CardinalityOptionsField";
import { PageContainer, Content, Header } from "../Drawer/PageContainer";
import Alice from "../Display/Alice";
import RemoveDialog from "../Shared/Remove/RemoveDialog";
import SaveDialog from "../Shared/Remove/SaveDialog";
import Loader from "../Shared/Loader/loader";
import { MsalContext } from "@azure/msal-react";
import { CheckForInternalUser } from "../Helpers/miscellaneous";
import ErrorMessage from '../Shared/Error/ErrorMessage'
import Scrollable from "../Shared/Edit/Scrollable";
import { callApiWithAuthorization } from "../../API/CallApi";
import Upgarde from "../Shared/Subscription/Upgrade";
import ServerError from "../Shared/Error/ServerError";
import InnerLoader from "../Shared/Loader/InnerLoader";
import { OverlayLoader } from "../Shared/Loader/OverlayLoader";
import { ENTITY_LABEL } from "../Helpers/Labels/EntityLabel";
import { ATTRIBUTE_LABEL } from "../Helpers/Labels/AttributeLabel";
import WorkspaceAppModelContext from "../../Context/Workspace/WorkspaceAppModelContext";
import AliceRelationRecommendationDialog from "./Recommendation/AliceRelationRecommendationDialog";
import { checkIfContradictiveRelationsExist } from "./utils";
import { getProjectRelations } from "../Helpers/Schema/Schema";
import { withTranslation } from "react-i18next";
import { getEntities } from "../../API/Entity/Entity";
import { deleteEntityRelation, deleteEntityRelationMirrorAttribute, deleteEntityRelationReferenceAttribute, findFormulaReferencesForUnlink, updateEntityRelation } from "../../API/EntityRelations/EntityRelations";
import { getProject, updateProject } from "../../API/Project/project";
import { getAttributes, updateAttribute } from "../../API/Attribute/Attribute";
import { propogateChangeToRealtimeIframe } from "../Helpers/Runtime/runtime";

class DragCell extends React.Component {
    render() {
        return (
            <td
                onDragOver={(e) => {
                    DragCell.reorder(this.props.dataItem);
                    e.preventDefault();
                    e.dataTransfer.dropEffect = "copy";
                }}
                onDragEnd={(e) => {
                    e.preventDefault();
                    DragCell.endDrag(this.props.dataItem);
                }}
            >
                <span
                    draggable="true"
                    style={{ cursor: "move" }}
                    onDragStart={(e) => {
                        DragCell.dragStart(this.props.dataItem);
                        e.dataTransfer.setData("dragging", "");
                    }}
                >
                    {this.props.dataItem._id}
                </span>
            </td>
        );
    }
}

class LinkedEntity extends Component {
    static contextType = MsalContext;

    LinkText = {
        "1-1": "One to One",
        "1-*": "One to Many",
        "*-*": "Many to Many",
    };

    SubmitButton = React.createRef();

    AttributeItem = (li, itemProps) => {
        const index = itemProps.index;
        const itemChildren = (
            <span>
                {li.props.children}
                {itemProps.dataItem.relName
                    ? "- " + itemProps.dataItem.relName
                    : ""}
            </span>
        );
        return React.cloneElement(li, li.props, itemChildren);
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            data: [],
            panes: [
                { collapsible: false },
                { size: "475px", min: "475px", collapsible: false },
            ],
            showAddLinkedEntityDialog: false,
            toLinkEntity: { name: `Select ${ENTITY_LABEL}`, _id: "" },
            relationName: "",
            reverseRelationName: "",
            showReferenceAttribute: false,
            referenceAttribute: { attributeName: `Select ${ATTRIBUTE_LABEL}`, _id: "" },
            attributesOfSelectedEntity: [],
            filterableEntities: [],
            SideData: {},
            selectedId: "",
            previousSelectedId: "",
            toSelectId: "",
            draggedOverItemIndex: -1,
            activeItemIndex: -1,
            isInternalUser: false,
            oneManyLinkWithSameEntity: false,
            showUpgradeDailog: false,
            contradictiveRelationError: {
                isValid: true,
                message: "",
            },
            selected: {},
            processingLinkedEntity: false,
            referenceAttr: [],
            referenceChecked: false,
            showAliceGPTDialog: false,
            recommendedRelations: [],
            isEditPanelSaveDisabled: true
        };

        this.SidebarSubentity = React.createRef();
        DragCell.reorder = this.reorder.bind(this);
        DragCell.dragStart = this.dragStart.bind(this);
        DragCell.endDrag = this.endDrag.bind(this);
    }

    componentDidMount = async () => {
        this.getAllEntities();
        this.getAllLinkedEntities();
        this.getProjectInternalModeStatus();

        window.addEventListener("message", this.handleMessage);
        // const currentOrganization = this.props.organizations.find(org => org._id === this.props.organizationId);
        // this.props.i18n.changeLanguage(currentOrganization.platformLanguage);
    };

    componentWillUnmount = () => {
        window.removeEventListener("message", this.handleMessage);
    }

    handleMessage = (event) => {
        if (event.origin === window.location.origin && typeof event.data === "string") {
            const data = JSON.parse(event.data);
            if (data.type === "GET_CONTEXT_REALTIME_API") {
                debugger;
                propogateChangeToRealtimeIframe(
                    this.props.organization._id,
                    data.instanceId,
                    "changeContext",
                    {
                        entityRelationId: this.state.SideData?.relationId,
                    }
                )
            }
        }
    }
    
    componentDidUpdate = (prevProps, prevState) => {
        // first condition - not disabled indicates button is enabled meaning there are unsaved changes
        // second condition - disabled indicates button is disabled meaning there are no unsaved changes
        if (!prevState.isEditPanelSaveDisabled && this.state.isEditPanelSaveDisabled && this.state.toSelectId) {
            const SideData = this.state.data.find(
                (e) => e.relationId === this.state.toSelectId
            );
            this.selectElement({ relationId: this.state.toSelectId, dataItem: SideData });
        }
    }

    rowRender = (trElement, props) => {
        const trProps = { className: "k-master-row" };
        if (props.dataItem.selected) {
            trProps.className += " k-state-selected";
        }
        if (props.dataItem.isHovered) {
            if (this.state.activeItemIndex > this.state.draggedOverItemIndex) {
                trProps.className = " hovered-row-above";
            } else {
                trProps.className = " hovered-row-below";
            }
        }
        return React.cloneElement(trElement, trProps, trElement.props.children);
    };

    render() {
        if (this.state.loading) {
            return <Loader />;
        }

        if (this.state.showServerError) {
            return (
                <ServerError
                    error={this.state.errorMessage} />
            )
        }

        const { t } = this.props;

        return (
            <>
                {this.state.visible && (
                    <SaveDialog
                        toggleSaveDialog={this.Discard}
                        onSave={this.Save}
                        onCancel={this.Discard}
                        message={t("message", { ns: "linked_entity/save_dialog" })}
                        Title={t("title", { ns: "linked_entity/save_dialog" })}
                        SaveButtonText={t("buttons.save", { ns: "linked_entity/save_dialog" })}
                        cancelButtonText={t("buttons.cancel", { ns: "linked_entity/save_dialog" })}
                    />
                )}
                {this.state.UnlinkPopup && (
                    <RemoveDialog
                        showLoader={this.state.processingLinkedEntity}
                        loading={this.state.processingLinkedEntity}
                        toggleDeleteDialog={this.toggleUnlinkDialog}
                        onDelete={this.UnlinkConfirmation}
                        message={this.state.referenceAttr && this.state.referenceAttr.length > 0 ?
                            t("message.with_reference_attribute", {
                                ns: "linked_entity/remove_dialog",
                                fromEntity: this.getEntityToUnlink()?.fromEntity?.label,
                                toEntity: this.getEntityToUnlink()?.toEntity?.label
                            }) :
                            t("message.without_reference_attribute", {
                                ns: "linked_entity/remove_dialog",
                                fromEntity: this.getEntityToUnlink()?.fromEntity?.label,
                                toEntity: this.getEntityToUnlink()?.toEntity?.label
                            })
                        }
                        Title={t("title", { ns: "linked_entity/remove_dialog" })}
                        cancelButtonText={t("buttons.cancel", { ns: "linked_entity/remove_dialog" })}
                        deleteButtonText={t("buttons.unlink", { ns: "linked_entity/remove_dialog" })}
                        icon="unlink"
                        referenceAttr={this.state.referenceAttr}
                        hideDeleteButton={this.state.referenceChecked && this.state.referenceAttr.length > 0}
                        hideCancelButton={this.state.referenceChecked && this.state.referenceAttr.length > 0}
                        orgName={this.props.orgName}
                        projectName={this.props.projectName}
                        referenceMessage={t("message.update_formula")}
                    />
                )}
                {this.state.showChangeCardinalityPopup && (
                    <Dialog
                        title={t("title", { ns: "linked_entity/change_cardinality_dialog" })}
                        onClose={this.toggleCardinalityPopup}
                        width={'90%'}
                    >
                        {this.state.processingLinkedEntity && <OverlayLoader />}
                        <form>
                            <span className="mt-2 me-2">
                                <ErrorMessage
                                    valid={
                                        this.state.contradictiveRelationError
                                            .isValid
                                    }
                                    error={
                                        this.state.contradictiveRelationError
                                            .message
                                    }
                                />
                            </span>
                            <CardinalityOptionsField
                                selected={this.state.newCardinality}
                                firstEntityName={
                                    this.state.toUpdate.fromEntity.name
                                }
                                secondEntityName={
                                    this.state.toUpdate.toEntity.name
                                }
                                onSelect={this.handleCardinality}
                                showSelected={true}
                            />
                            <DialogActionsBar layout="end">
                                <div className="w-100 d-flex justify-content-end">
                                    {this.state.processingLinkedEntity && (
                                        <small className="mt-2">
                                            <div className="d-inline-block">
                                                <InnerLoader borderColor="green" />
                                                <span className="me-4 text-danger"></span>
                                            </div>
                                        </small>
                                    )}
                                    <button
                                        onClick={this.toggleCardinalityPopup}
                                        className="me-1 btn btn-secondary"
                                    >
                                        {t("buttons.cancel", { ns: "linked_entity/change_cardinality_dialog" })}
                                    </button>
                                    <button
                                        onClick={this.updateCardinality}
                                        disabled={this.isCardinalityChanged()}
                                        className="btn btn-primary"
                                    >
                                        {t("buttons.update", { ns: "linked_entity/change_cardinality_dialog" })}
                                    </button>
                                </div>
                            </DialogActionsBar>
                        </form>
                    </Dialog>
                )}
                <CreateLinkDialog
                    useSuspense={false}
                    organizationId={this.props.organizationId}
                    projectId={this.props.projectId}
                    visible={this.state.showAddLinkedEntityDialog}
                    entities={this.state.entities}
                    attributes={this.state.attributes}
                    toggle={this.toggleAddLinkedEntityDialog}
                    onCreate={this.addRelationToGrid}
                    updateLink={this.updateLink}
                    relations={this.state.allLinkedEntities}
                    recommendedRelations={this.state.recommendedRelations}
                    isAccessedFromWorkspace={this.props.isAccessedFromWorkspace}
                    onUpgradeRequired={this.showUpgradeDialog}
                />
                {
                    this.state.showAliceGPTDialog &&
                    <AliceRelationRecommendationDialog
                        organizationId={this.props.organizationId}
                        projectId={this.props.projectId}
                        entities={this.state.entities}
                        relations={this.state.allLinkedEntities}
                        onRelationsCreated={this.addCreatedRelationsToGrid}
                        toggleDialog={this.toggleAliceGPTDialog} 
                        recommendedRelations={this.state.recommendedRelations}
                        setRecommendedRelations={this.setRecommendedRelations}
                        />
                }
                <PageContainer>
                    <div className="chngBtn1">
                        <Header
                            header={t("header.title", { ns: "linked_entity/common" })}
                            showAction={true}
                            actionText={t("header.buttons.new_relation", { ns: "linked_entity/common" })}
                            actionTestId="new-relation-btn"
                            actionClicked={() => this.toggleAddLinkedEntityDialog(false)}
                            showHelpCenter={(this.state.isInternalUser && this.props.advancedMode) ? true : false}
                            user={this.props.user}
                            helpCenterFor={"LinkedEntity"}
                            // action3Text={this.props.advancedMode ? "Alice AI Recommendation" : null}
                            // action3Disabled={false}
                            // action3Icon={this.props.advancedMode ? "fas fa-lightbulb-on" : null}
                            // action3Clicked={this.props.advancedMode ? this.toggleRecommendRelations : null}
                            action2Text={this.props.showAIButtons && t("header.buttons.alice_ai", { ns: "linked_entity/common" })}
                            action2Disabled={false}
                            action2Icon={this.props.showAIButtons && "fas fa-lightbulb-on"}
                            action2Clicked={this.props.showAIButtons && this.toggleAliceGPTDialog}
                        >
                            <DropDownList
                                style={{ minWidth: "200px" }}
                                data={this.state.filterableEntities}
                                textField="name"
                                className="me-2"
                                value={this.state.entityToFilterOn}
                                onChange={this.filterLinks}
                            />
                        </Header>
                    </div>
                    <Content>
                        {
                            this.state.showUpgradeDailog &&
                            <Upgarde
                                organization={this.props.organization}
                                Headline={'Need to build <br/>bigger apps? '}
                                toggleDialog={this.toggleUpgradeDailog}
                                Type={'Pro'}
                            />
                        }
                        {this.state.data.length === 0 && (
                            <Alice header="Create Object Relation">
                                {this.props.t("message_1")}
                                <br />
                                <br />
                                {this.props.t("message_2")}
                            </Alice>
                        )}
                        {this.state.data.length > 0 && (
                            <>
                                <Splitter
                                    className="splitter-holder"
                                    panes={this.state.panes}
                                    onChange={this.onSplitterSizeChange}
                                >
                                    <div className="py-3 h-100 m-9">
                                        <Scrollable>
                                            <Grid
                                                data={this.state.data.map(
                                                    (item, index) => ({
                                                        ...item,
                                                        selected:
                                                            item.relationId ===
                                                            this.state.selectedId,
                                                        isHovered:
                                                            index ===
                                                            this.state
                                                                .draggedOverItemIndex,
                                                        index,
                                                    })
                                                )}
                                                onRowClick={this.selectElement}
                                                selectedField="selected"
                                            >
                                                <Column
                                                    field="_id"
                                                    title="#"
                                                    width={60}
                                                    cell={DragCell}
                                                />
                                                <Column
                                                    title={this.props.t("grid.object_1", { ns: "linked_entity/common" })}
                                                    cell={(props) => (
                                                        <td>
                                                            {/* <a className="link" href={`/${this.props.orgName}/${this.props.projectName}/Entities/${props.dataItem.fromEntity.sysName}/Attributes`}>{props.dataItem.fromEntity.name}</a> */}
                                                            {
                                                                props.dataItem
                                                                    .fromEntity.name
                                                            }
                                                        </td>
                                                    )}
                                                />
                                                <Column
                                                    title={this.props.t("grid.cardinality", { ns: "linked_entity/common" })}
                                                    cell={(props) => (
                                                        <td>
                                                            <span
                                                                className="link"
                                                                onClick={() =>
                                                                    this.toggleCardinalityPopup(
                                                                        props.dataItem
                                                                    )
                                                                }
                                                            >
                                                                {
                                                                    props.dataItem
                                                                        .cardinalityText
                                                                }
                                                            </span>
                                                        </td>
                                                    )}
                                                />
                                                <Column
                                                    title={this.props.t("grid.object_2", { ns: "linked_entity/common" })}
                                                    cell={(props) => (
                                                        <td>
                                                            {/* <a className="link" href={`/${this.props.orgName}/${this.props.projectName}/Entities/${props.dataItem.toEntity.sysName}/Attributes`}>{props.dataItem.toEntity.name}</a> */}
                                                            {
                                                                props.dataItem
                                                                    .toEntity.name
                                                            }
                                                        </td>
                                                    )}
                                                />
                                            </Grid>
                                        </Scrollable>
                                    </div>
                                    <div className="h-100">
                                        {
                                            <WorkspaceAppModelContext.Consumer>
                                                {
                                                    ({ state, mutators }) => (
                                                        <LinkedEntitySidebar
                                                            useSuspense={false}
                                                            orgName={this.props.orgName}
                                                            organizationId={this.props.organizationId}
                                                            projectId={this.props.projectId}
                                                            projectName={this.props.projectName}
                                                            allData={this.state.allLinkedEntities}
                                                            SideData={this.state.SideData}
                                                            Unlink={this.Unlink}
                                                            ref={this.SidebarSubentity}
                                                            updateElement={this.updateElement}
                                                            entityId={this.props.entityId}
                                                            sysName={this.props.sysName}
                                                            showOrphanRecordFields={this.state.isInternalModeActivated}
                                                            isAccessedFromWorkspace={this.props.isAccessedFromWorkspace}
                                                            selectEntity={this.props.selectEntity}
                                                            setEditPanelChanged={(isEditPanelSaveDisabled) => this.setState({ isEditPanelSaveDisabled })}
                                                            mutators={mutators}
                                                        />
                                                    )
                                                }
                                            </WorkspaceAppModelContext.Consumer>
                                        }
                                    </div>
                                </Splitter>
                            </>
                        )}
                    </Content>
                </PageContainer>
            </>
        );
    }

    onSplitterSizeChange = (e) => {
        this.setState({ panes: e.newState });
    };

    checkFormulaReferenceForUnlink = async () => {
        this.setState({
            referenceAttr: [],
            referenceChecked: false
        });
        const response = await findFormulaReferencesForUnlink({
            oneEntityId: this.state.SideData.fromEntity._id,
            oneEntityName: this.state.SideData.fromEntity.name,
            oneEntitySysName: this.state.SideData.fromEntity.sysName,
            manyEntityId: this.state.SideData.toEntity._id,
            manyEntityName: this.state.SideData.toEntity.name,
        })
        this.setState({
            referenceAttr: Array.from(new Set(response.message)),
            referenceChecked: true,
            processingLinkedEntity: false
        });
    }
    // Get data part
    getAllEntities = async () => {
        try {
            let entities = await getEntities(this.props.projectId);
            entities = entities.filter((entity) => entity.isUserEntity !== true);
            entities = entities.sort((a, b) => a.order - b.order);
            const filterableEntities = [
                {
                    name: this.props.t("show_all_objects_option", { ns: "linked_entity/common" }),
                    _id: "",
                },
                ...entities,
            ];
            const entityToFilterOn = filterableEntities[0];
            let isInternalUser = CheckForInternalUser(this.props.user.email);
            this.setState({
                isInternalUser: isInternalUser,
                entityToFilterOn,
                filterableEntities,
                entities,
            });
        } catch (e) {
            console.error(e);
            this.setState({
                showServerError: true,
                errorMessage: this.props.t("fetch_error", { ns: "linked_entity/common" })
            });
        }
    };

    getAllLinkedEntities = async () => {
        try {
            const linkedEntities = await getProjectRelations(this.props.projectId);

            if (linkedEntities.length > 0) {
                linkedEntities.forEach(this.setProperties);
            }

            const allLinkedEntities = linkedEntities;

            let toSelectElement;

            if (allLinkedEntities && allLinkedEntities.length > 0) {
                if (this.props.selectedId) {
                    toSelectElement = allLinkedEntities.find(
                        (rel) => rel.relationId === this.props.selectedId
                    );
                } else {
                    toSelectElement = allLinkedEntities[0];
                }
            }

            this.setState(
                {
                    allLinkedEntities,
                    data: linkedEntities,
                    selectedId: toSelectElement ? toSelectElement.relationId : "",
                    SideData: toSelectElement ? toSelectElement : {},
                    previousSelectedId: "",
                    toSelectId: "",
                    visible: false,
                    loading: false
                },
                () => {
                    debugger;
                    if (this.state.data.length > 0 && this.state.selectedId) {
                        propogateChangeToRealtimeIframe(this.props.organizationId, this.props.instanceId, "entityRelationSelected", this.state.SideData);
                    }
                }
                // () => {
                //     if (this.state.data.length > 0) {
                //         let toSelectElement;

                //         if (this.props.selectedId) {
                //             toSelectElement = this.state.data.find(
                //                 (rel) => rel.relationId === this.props.selectedId
                //             );
                //         } else {
                //             toSelectElement = this.state.data[0];
                //         }

                //        this.selectElement(toSelectElement);
                //     }
                // }
            );
        } catch (e) {
            console.error(e);
            this.setState({ showServerError: true, errorMessage: this.props.t("fetch_error", { ns: "linked_entity/common" }) });
        }
    };

    getProjectInternalModeStatus = async () => {
        try {
            const project = await getProject(this.props.projectId);
            this.setState({
                isInternalModeActivated: project.developerMode === true,
            });
        } catch (e) {
            console.error(e);
            this.setState({ showServerError: true, errorMessage: this.props.t("fetch_error", { ns: "linked_entity/common" }) });
        }
    }

    /*
     *  Add Linked Entity Part
     */

    // Handle linked entity popup
    toggleAddLinkedEntityDialog = (showUpgradeDailog) => {
        this.setState({
            showUpgradeDailog: showUpgradeDailog,
            showAddLinkedEntityDialog: !this.state.showAddLinkedEntityDialog,
            toLinkEntity: { name: `Select ${ENTITY_LABEL}`, _id: "" },
            relationName: "",
            reverseRelationName: "",
            showReferenceAttribute: false,
            referenceAttribute: { name: `Select ${ATTRIBUTE_LABEL}`, _id: "" },
        });
    };

    toggleUpgradeDailog = () => {
        this.setState({
            showUpgradeDailog: !this.state.showUpgradeDailog
        })
    }

    showUpgradeDialog = () => {
        this.setState({ showUpgradeDailog: true });
    }

    toggleCardinalityPopup = (selected) => {
        if (!selected.isManagerAttributeRelation) {
            this.setState({
                toUpdate: selected || {},
                newCardinality: selected ? selected.cardinality : "",
                showChangeCardinalityPopup: !this.state.showChangeCardinalityPopup,
                contradictiveRelationError: {
                    isValid: true,
                    message: "",
                },
            });
        }
    };

    isCardinalityChanged = () => {
        if (this.state.contradictiveRelationError.isValid) {
            return (
                this.state.toUpdate.cardinality === this.state.newCardinality
            );
        } else {
            return true;
        }
    };

    checkIfContradictiveRelationExistsFor = (cardinality) => {
        if (cardinality === "1-*") {
            const {
                toUpdate: {
                    relationId,
                    fromEntity: { _id: fromEntityId },
                    toEntity: { _id: toEntityId },
                },
                data: relations,
            } = this.state;
            return checkIfContradictiveRelationsExist(
                this.state.allLinkedEntities,
                {
                    relationId,
                    fromEntity: { _id: fromEntityId },
                    toEntity: { _id: toEntityId },
                    cardinality
                }
            )
        }
        return false;
    };

    // Filter
    filterLinks = (e) => {
        const { value: entityToFilterOn } = e.target;
        const { allLinkedEntities } = this.state;
        if (entityToFilterOn._id) {
            const filteredData = allLinkedEntities.filter(
                (link) =>
                    link.fromEntity._id === entityToFilterOn._id ||
                    link.toEntity._id === entityToFilterOn._id
            );
            this.setState(
                {
                    entityToFilterOn,
                    data: filteredData,
                    selectedId: "",
                    SideData: {},
                },
                () => {
                    if (filteredData.length > 0) {
                        this.selectElement(filteredData[0]);
                    }
                }
            );
            return;
        }
        this.setState(
            {
                entityToFilterOn,
                data: allLinkedEntities,
                selectedId: "",
                SideData: {},
            },
            () => {
                if (allLinkedEntities.length > 0) {
                    this.selectElement(allLinkedEntities[0]);
                }
            }
        );
    };

    // After creating relation
    addRelationToGrid = async (relation) => {
        try {
            const { data: prevData, allLinkedEntities } = this.state;
            relation.cardinalityText = this.props.t("cardinality." + relation.cardinality, { ns: "linked_entity/recommended_relation_card" })
            const data = [...prevData, relation];
            allLinkedEntities.push(relation);
            if (data.length > 1) {
                await this.removePreviousReferenceAttribute(data);
            }
            this.setState(
                {
                    data,
                    allLinkedEntities
                },
                () => {
                    this.selectElement(relation);
                }
            );
        } catch (e) {
            this.setState({ showServerError: true });
        }
    };

    removePreviousReferenceAttribute = async (relations) => {
        const {
            relationId,
            fromEntity,
            toEntity,
        } = relations[relations.length - 1];
        const relationWithSameEntityIndex = relations.findIndex(
            (link) =>
                link.fromEntity._id === fromEntity._id &&
                link.toEntity._id === toEntity._id &&
                link.showReferenceAttribute &&
                link.relationId !== relationId
        );
        if (relationWithSameEntityIndex > -1) {
            const relationWithSameEntity =
                relations[relationWithSameEntityIndex];
            // await updateRelationship(
            //     relationWithSameEntity.relationId,
            //     "Has_Entity",
            //     {
            //         ...relationWithSameEntity,
            //         showReferenceAttribute: false,
            //     }
            // );
            // await callApiWithAuthorization(
            //     "/api/v0/linkedEntity/" +
            //     relationWithSameEntity.relationId +
            //     "/referenceAttribute?projectId=" + this.props.projectId,
            //     {
            //         method: "DELETE",
            //         headers: {
            //             "Content-Type": "application/json",
            //         },
            //     }
            // );
            await deleteEntityRelationReferenceAttribute(relationWithSameEntity.relationId);
            relationWithSameEntity.showReferenceAttribute = false;
            relationWithSameEntity.referencedAttribute = {};
        }
    };

    updateLink = (relation) => {
        const { data: prevData } = this.state;
        const relIndex = prevData.findIndex(
            (link) => link.relationId === relation.relationId
        );
        prevData[relIndex] = relation;
        const data = [...prevData];
        this.setState({
            data,
        });
    };

    updateCardinality = async (e) => {
        try {
            e.preventDefault();
            this.setState({ processingLinkedEntity: true })
            const { data, toUpdate, newCardinality } = this.state;
            if (toUpdate.cardinality !== newCardinality) {
                // await callApiWithAuthorization(
                //     "/api/v0/linkedEntity/" +
                //     toUpdate.relationId +
                //     "/referenceAttribute?projectId=" + this.props.projectId,
                //     {
                //         method: "DELETE",
                //         headers: {
                //             "Content-Type": "application/json",
                //         },
                //     }
                // );
                await deleteEntityRelationReferenceAttribute(toUpdate.relationId);
                toUpdate.lookupAttribute = {};
                toUpdate.referencedAttribute = {};
                toUpdate.showReferenceAttribute = false;
            }
            toUpdate.cardinality = newCardinality;
            toUpdate.cardinalityText = this.props.t("cardinality." + toUpdate.cardinality, { ns: "linked_entity/recommended_relation_card" });
            const toUpdateIndex = data.findIndex(
                (link) => link.relationId === toUpdate.relationId
            );
            data[toUpdateIndex] = toUpdate;
            // await updateRelationship(
            //     toUpdate.relationId,
            //     "Has_Entity",
            //     {
            //         cardinality: toUpdate.cardinality,
            //         showReferenceAttribute: toUpdate.showReferenceAttribute,
            //     }
            // )
            await updateEntityRelation(
                toUpdate.relationId,
                {
                    cardinality: toUpdate.cardinality,
                    showReferenceAttribute: toUpdate.showReferenceAttribute,
                }
            )
            // await updateRelationWithProperty(
            //     "Has_Entity",
            //     "id",
            //     toUpdate.relationId,
            //     {
            //         cardinality: toUpdate.cardinality,
            //         showReferenceAttribute: toUpdate.showReferenceAttribute,
            //     }
            // );
            this.setState(
                {
                    data,
                    processingLinkedEntity: false
                },
                () => {
                    if (
                        this.state.SideData.relationId ===
                        data[toUpdateIndex].relationId
                    ) {
                        this.setState(
                            {
                                SideData: {},
                            },
                            () => {
                                this.setState({
                                    SideData: data[toUpdateIndex],
                                });
                            }
                        );
                    }
                }
            );
            this.toggleCardinalityPopup(toUpdate);
        } catch (e) {
            this.setState({ showServerError: true });
        }
    };

    handleCardinality = (newCardinality) => {
        let { contradictiveRelationError } = this.state;
        const exists = this.checkIfContradictiveRelationExistsFor(newCardinality);
        if (exists) {
            contradictiveRelationError.isValid = false;
            contradictiveRelationError.message = this.props.t("errors.contradictive_relation", { ns: "linked_entity/create_link_dialog" })
        } else {
            contradictiveRelationError.isValid = true;
            contradictiveRelationError.message = "";
        }
        this.setState({
            newCardinality,
            contradictiveRelationError,
        });
    };

    /*
     *  Linked Entity Grid Part
     */

    // Select a linked entity
    selectElement = (e) => {
        let selectedId = e.relationId;
        let SideData = e.dataItem;

        if (!selectedId) {
            selectedId = e.dataItem.relationId;
        }

        if (this.state.SideData && this.state.SideData.relationId === selectedId) {
            return;
        }

        if (!SideData) {
            SideData = e;
        }

        if (this.state.isEditPanelSaveDisabled !== undefined && this.state.isEditPanelSaveDisabled === false) {
            this.setState({
                visible: true,
                previousSelectedId: this.state.selectedId,
                toSelectId: selectedId,
            });
        } else {
            this.setState({
                selectedId: selectedId,
                SideData: SideData,
                previousSelectedId: "",
                toSelectId: "",
                visible: false,
            });
            propogateChangeToRealtimeIframe(this.props.organizationId, this.props.instanceId, "entityRelationSelected", SideData);
        }
    };

    updateElement = (linkedEntityData) => {
        let data = this.state.data;
        let linkedEntityIndex = data.findIndex(
            (relation) => relation.relationId === linkedEntityData.relationId
        );
        linkedEntityData._id = linkedEntityIndex + 1;
        linkedEntityData.cardinalityText = this.props.t("cardinality." + linkedEntityData.cardinality, { ns: "linked_entity/recommended_relation_card" });
        data[linkedEntityIndex] = linkedEntityData;

        if (this.state.previousSelectedId.trim() === "") {
            if (this.state.selectedId === linkedEntityData.relationId) {
                this.setState({
                    data: data,
                    SideData: linkedEntityData,
                });
            }
        } else {
            let toSelectElement = data.find(
                (relation) => relation.relationId === this.state.toSelectId
            );
            this.selectElement(toSelectElement);
        }
    };

    // Re-order part

    reorder(dataItem) {
        if (this.state.activeItem.relationId === dataItem.relationId) {
            if (
                this.state.draggedOverItemIndex !== this.state.activeItemIndex
            ) {
                this.setState({ draggedOverItemIndex: -1 });
            }
            return;
        }

        this.setState({
            activeItem: this.state.activeItem,
            draggedOverItemIndex: dataItem.index,
        });
    }

    updateOrder = (id, ordertoUpdate) => {
        let element = this.state.data.find((x) => x.relationId === id);

        callApiWithAuthorization("/api/v0/relationships", {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                id: id,
                label: element.inherited
                    ? "InheritsLinkedEntity"
                    : "Has_Entity",
                properties: {
                    cardinalities1: element.cardinalities1,
                    cardinalities2: element.cardinalities2,
                    relationName: element.relationName,
                    reverseRelationName: element.reverseRelationName,
                    order: ordertoUpdate,
                },
            }),
        });
    };

    endDrag(dataItem) {
        let { activeItemIndex, draggedOverItemIndex } = this.state;

        if (draggedOverItemIndex === -1) {
            return;
        }

        let reorderedData = this.state.data.slice();
        reorderedData.splice(activeItemIndex, 1);
        reorderedData.splice(draggedOverItemIndex, 0, this.state.activeItem);
        let index = draggedOverItemIndex;

        let newOrder;

        if (reorderedData.length > 2) {
            if (index === reorderedData.length - 1) {
                newOrder =
                    parseInt(reorderedData[index - 1]["order"]) + 10000000000;
                ////console.log(index, newOrder);
                reorderedData[index]["order"] = newOrder;
                this.updateOrder(reorderedData[index].relationId, newOrder);
            } else if (index === 0) {
                newOrder = parseInt(reorderedData[1]["order"]);
                let prevElementOrder = parseInt(reorderedData[2]["order"]);
                let orderToSet = (prevElementOrder + newOrder) / 2;
                reorderedData[index]["order"] = newOrder;
                reorderedData[1]["order"] = orderToSet;
                this.updateOrder(reorderedData[index].relationId, newOrder);
                this.updateOrder(reorderedData[1].relationId, orderToSet);
            } else {
                let prevItemOrder = parseInt(reorderedData[index - 1]["order"]);
                let nextItemOrder = parseInt(reorderedData[index + 1]["order"]);
                newOrder = (prevItemOrder + nextItemOrder) / 2;
                reorderedData[index]["order"] = newOrder;
                this.updateOrder(reorderedData[index].relationId, newOrder);
            }
        } else {
            let firstOrder = reorderedData[0]["order"];
            let secondOrder = reorderedData[1]["order"];

            reorderedData[0]["order"] = secondOrder;
            reorderedData[1]["order"] = firstOrder;

            this.updateOrder(reorderedData[0].relationId, secondOrder);
            this.updateOrder(reorderedData[1].relationId, firstOrder);
        }

        for (let i = 0; i < reorderedData.length; i++) {
            reorderedData[i]._id = i + 1;
        }

        this.setState({
            data: reorderedData,
            selectedId: this.state.oldSelectedId,
        });
    }

    dragStart(dataItem) {
        var oldSelectedId = this.state.selectedId;
        this.setState({
            data: this.state.data,
            activeItem: dataItem,
            oldSelectedId: oldSelectedId,
            selectedId: dataItem.relationId,
            activeItemIndex: dataItem.index,
        });
    }

    // Save and continue part
    Save = async (e) => {
        await this.SidebarSubentity.current.Save(e);
    };

    Discard = () => {
        // this.SidebarSubentity.current.continueWithoutSaving(() => {
        //     let element = this.state.data.find(
        //         (e) => e.relationId === this.state.toSelectId
        //     );
        //     this.selectElement(element);
        this.setState({
            visible: false,
            previousSelectedId: "",
            toSelectId: "",
        });
    };

    // Unlink linked entity part

    toggleUnlinkDialog = (e) => {
        this.setState({
            UnlinkPopup: false,
        });
    };

    Unlink = (e) => {
        this.setState({
            UnlinkPopup: true,
            processingLinkedEntity: true
        });
        var res = this.checkFormulaReferenceForUnlink();
    };

    getEntityToUnlink = () => {
        return this.state.data.find((e) => e.relationId === this.state.SideData.relationId);
    }

    UnlinkConfirmation = async (e) => {
        this.deleteFormula();
        e.target.disabled = true;
        this.setState({ processingLinkedEntity: true })
        let element = this.state.data.find((x) => x.relationId === this.state.selectedId);
        await this.remove(element);
        this.setState({
            UnlinkPopup: !this.state.UnlinkPopup,
            processingLinkedEntity: false
        });
    };

    // delete formula
    deleteFormula = async () => {
        let referenceAttr = this.state.referenceAttr
        for (let item of referenceAttr) {
            const allEntityAttributes = await getAttributes(item.entityId);
            const linkedAttributes = allEntityAttributes.find(attrItem => attrItem._id === item.attributeId);
            linkedAttributes.formula = '';
            linkedAttributes.formulaJson = '';
            const triggerSettingObj = JSON.parse(linkedAttributes.triggerSetting);
            triggerSettingObj.formulaEnabled = false;
            const updatedTriggerSettingStr = JSON.stringify(triggerSettingObj);
            linkedAttributes.triggerSetting = updatedTriggerSettingStr;
            linkedAttributes.readOnly = false;
            const res = await updateAttribute(linkedAttributes._id, linkedAttributes);

        }
    }

    remove = async (dataItem) => {
        await deleteEntityRelation(dataItem.relationId);

        let data = this.state.data;
        const allLinkedEntities = this.state.allLinkedEntities.filter(relation => (
            relation.relationId !== dataItem.relationId
        ));
        let index = data.findIndex((p) => p.relationId === dataItem.relationId);
        let toGet = 0;

        data.splice(index, 1);

        for (let i = 0; i < data.length; i++) {
            data[i]._id = i + 1;
        }

        this.setState({ allLinkedEntities, data: data }, () => {
            debugger;
            if (index === 0) {
                if (data.length > 0) {
                    // Here setstate is utilized intentionally
                    // to prevent opening of the save dialog
                    this.setState({
                        selectedId: data[toGet].relationId,
                        SideData: data[toGet],
                        previousSelectedId: "",
                        toSelectId: "",
                        visible: false,
                    });
                } else {
                    this.setState({
                        SideData: {},
                    });
                }
            } else {
                toGet = index - 1;

                if (this.state.selectedId === dataItem.relationId) {
                    // Here setstate is utilized intentionally
                    // to prevent opening of the save dialog
                    this.setState({
                        selectedId: data[toGet].relationId,
                        SideData: data[toGet],
                        previousSelectedId: "",
                        toSelectId: "",
                        visible: false,
                    });
                }
            }
            if (data.length === 0) {
                this.setState({ selectedId: "" })
            }
        });
    };

    setProperties = (linkedEntity, index) => {
        const { LinkText } = this;
        linkedEntity.cardinalityText = this.props.t("cardinality." + linkedEntity.cardinality, { ns: "linked_entity/recommended_relation_card" });
        linkedEntity.referencedAttribute =
            linkedEntity.referencedAttribute === null
                ? {}
                : linkedEntity.referencedAttribute;
        if (linkedEntity.lookupAttribute) {
            linkedEntity.lookupAttribute.required =
                linkedEntity.lookupAttribute.required === true;
            linkedEntity.isLookupRequired =
                linkedEntity.lookupAttribute.required;
        } else {
            linkedEntity.lookupAttribute = {};
        }
        linkedEntity.relationIdentifier = linkedEntity.identifier;
        delete linkedEntity.identifier;
        linkedEntity._id = index + 1;
    }

    toggleAliceGPTDialog = (e) => {
        this.setState({
            showAliceGPTDialog: !this.state.showAliceGPTDialog,
        });
    }

    setRecommendedRelations = (recommendedRelations) => {
        this.setState({ recommendedRelations });
    }

    getEntityNames = () => {
        return this.state.entities.map(entity => entity.name);
    }

    addCreatedRelationsToGrid = (response) => {
        if (response.status && response.status === "Failure") {
            if (response.message === "Max Relations allowed limit reached") {
                this.toggleUpgradeDailog();
                return;
            }
        }
        response.forEach(this.setProperties);
        const { data, allLinkedEntities } = this.state;
        const newData = data.concat(response).map((relation, index) => ({ ...relation, _id: index + 1 }));
        const newAllRelations = allLinkedEntities.concat(response).map((relation, index) => ({ ...relation, _id: index + 1 }));
        this.setState({
            data: newData,
            allLinkedEntities: newAllRelations
        }, () => {
            if (response.length > 0) {
                this.selectElement(response[0]);
            }
        });
    }
}

export default withTranslation([
    "linked_entity/common",
    "linked_entity/save_dialog",
    "linked_entity/remove_dialog",
    "linked_entity/create_link_dialog",
    "linked_entity/recommended_relation_card",
    "linked_entity/change_cardinality_dialog",
    "linked_entity/cardinality_shapes",
    "linked_entity/recommended_relation_card"
])(LinkedEntity);
